import './CaseStudy.css';

export default function CaseStudy({ project, onBack }) {
  if (!project) return null;

  const { title, category, images, scopeTitle, description } = project;

  return (
    <section className="case-study-section">
      <div className="case-study-grid">

        {/* ── LEFT: Title + Images ── */}
        <div className="case-left">
          <h1 className="case-title">{title}</h1>
          <span className="case-category">{category}</span>

          <div className="case-images">
            {images.map((src, i) => (
              <div className="case-img-wrap" key={i}>
                <img src={src} alt={`${title} ${i + 1}`} className="case-img" />
              </div>
            ))}
          </div>
        </div>

        {/* ── RIGHT: Sidebar ── */}
        <aside className="case-sidebar">
          <span className="case-label">Project Scope</span>
          <h3 className="case-scope">{scopeTitle}</h3>

          <span className="case-label">Description</span>
          <p className="case-description">{description}</p>

          <span className="case-label">Share</span>
          <div className="case-share">
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
              target="_blank" rel="noreferrer" className="case-share-icon" aria-label="Share on Facebook"
            >f</a>
            <a
              href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}`}
              target="_blank" rel="noreferrer" className="case-share-icon" aria-label="Share on X"
            >𝕏</a>
            <a
              href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`}
              target="_blank" rel="noreferrer" className="case-share-icon" aria-label="Share on LinkedIn"
            >in</a>
          </div>

          <button className="case-back-btn" onClick={onBack}>
            <span className="case-back-arrow">←</span> Return to Portfolio
          </button>
        </aside>
      </div>
    </section>
  );
}
